<template>
  <div class="phone-input">
    <div class="title">{{ title }}</div>
    <div class="input">
      <input
        :value="phone"
        @keyup="inputPhone"
        pattern="\d*"
        type="tel"
        maxlength="11"
        :placeholder="placeholder"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "PhoneInput",
  props: {
    phone: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "+86"
    },
    placeholder: {
      type: String,
      default: "请输入手机号"
    }
  },
  data: function() {
    return {};
  },
  methods: {
    inputPhone(e) {
      if (/\D/g.test(e.target.value)) {
        let val = e.target.value.replace(/\D/g, "");
        this.$emit("doInput", val);
        e.target.value = val;
        return;
      }
      this.$emit("doInput", e.target.value);
    }
  }
};
</script>
<style lang="scss" scoped>
.phone-input {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #dcdcdc;
  display: flex;
  align-items: center;
  .title {
    width: 50px;
    text-align: left;
    line-height: 18px;
    font-size: 18px;
    height: 18px;
    color: #69707f;
    flex-shrink: 0;
    border-right: 1px solid #969fa9;
  }
  .input {
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 16px;
    input {
      font-size: 18px;
    }
  }
}
</style>
